export const CODE_LENGTH = 7;
export const KEYPAD_DIGITS = 10;

export const DIFFICULTY_OPTIONS = [3, 5, 7] as const;
export type Difficulty = (typeof DIFFICULTY_OPTIONS)[number];

export const DIFFICULTY_LABELS: Record<Difficulty, string> = {
  3: "EASY",
  5: "MEDIUM",
  7: "HARD",
};

export type RoundStatus = "active" | "cashed_out" | "busted";

export interface RoundStartRequest {
  stake: number;
  difficulty: Difficulty;
}

export interface RoundStartResponse {
  roundId: string;
  seedHash: string;
  stake: number;
  difficulty: Difficulty;
  codeLength: number;
  revealed: string;
  multiplier: number;
}

export interface PressRequest {
  digit: number;
}

export type PressResponse =
  | {
      safe: true;
      position: number;
      digit: number;
      revealed: string;
      multiplier: number;
      nextMultiplier: number | null;
      completed: boolean;
    }
  | {
      safe: false;
      position: number;
      digit: number;
      bombDigits: number[];
      revealed: string;
      lostStake: number;
    };

export interface CashoutResponse {
  roundId: string;
  payout: number;
  multiplier: number;
  balance: number;
  revealed: string;
  fullCode: string;
}

export interface VerifyResponse {
  roundId: string;
  seedHash: string;
  rawSeed: string;
  stake: number;
  difficulty: number;
  bombDigitsPerPos: number[][];
  fullCode: string;
  status: RoundStatus;
  createdAt: string;
}

export interface BalanceResponse {
  balance: number;
  currency: "DEMO";
}

export interface AuthResponse {
  token: string;
  user: {
    telegramId: number;
    username: string | null;
    firstName: string | null;
    balance: number;
  };
}
